import TextEditor from './TextEditor';
import { MentionedUser } from './TextEditor.props';

export default TextEditor;

export type { MentionedUser };
